import { AfterViewInit, Component, inject, viewChild } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjektService } from '../../../core/http/projekt.service';
import { DokumentBezeichnungDto } from '../../../core/models/base/dokument-bezeichnung-dto.model';
import { ProjektDto } from '../../../core/models/projekt/projekt-dto.model';
import { SearchBoxDatabinding } from '../../../core/models/shared/search-box-databinding.model';
import { UniversalSorter } from '../../../core/pipes/universal-sorter.pipe';
import { SearchBoxComponent } from '../../search-box/search-box.component';

@Component({
  selector: 'bpw-pr-selection',
  standalone: true,
  imports: [SearchBoxComponent],
  templateUrl: './pr-selection.component.html',
  providers: [UniversalSorter],
})
export class PrSelectionComponent implements AfterViewInit {
  private readonly _modalRef = inject(MdbModalRef<PrSelectionComponent>);
  private readonly _projektService = inject(ProjektService);
  private readonly _sorter = inject(UniversalSorter);
  private readonly _prSearchBox = viewChild<SearchBoxComponent>('prSearchBox');

  searchTerm = '';

  readonly databindingPr: SearchBoxDatabinding;

  constructor() {
    this.databindingPr = new SearchBoxDatabinding('', 'Projekt suchen...', true, true, true);
    this.databindingPr.getData = (searchTermInternal) => {
      return this._projektService.searchProjekteObservable(searchTermInternal).pipe(catchError(() => of('Fehler')));
    };
    this.databindingPr.getEmptySearchData = () => {
      return this._projektService.getLastUsedProjekteObservable().pipe(catchError(() => of('Fehler')));
    };
    this.databindingPr.handleResult = (result) => {
      const projekte = result as ProjektDto[];
      this.databindingPr.data = this._sorter.transform(projekte, 'dokument', true);
    };
  }

  ngAfterViewInit(): void {
    // Timeout nötig da sonst prSearchBox = undefined, wieso auch immer
    setTimeout(() => {
      this._prSearchBox()?.executeDirectSearch(this.searchTerm);
    }, 200);
  }

  prSelectedInternal(pr: DokumentBezeichnungDto): void {
    this._projektService.setLastUsedProjekt(pr.id);
    this._modalRef.close(pr);
  }

  closeModal(): void {
    this._modalRef.close();
  }
}
